import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Svg,
  Path,
} from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  container: {
    margin: '32px',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    // alignItems: 'center',
    marginBottom: '16px',
    flexDirection: 'row',
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '32px',
    flexDirection: 'row',
  },
  onlyFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  invoice: {
    fontSize: '32px',
  },
  marginB: {
    marginBottom: '32px',
  },
  maxWidth: {
    maxWidth: '200px',
  },
  flexCol: {
    display: 'flex',
    marginBottom: '16px',
    flexDirection: 'column',
  },
  page: {
    padding: 20,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    alignItems: 'center',
    fontSize: 10,
    width: '100%',
    display: 'flex',
  },
  tableCell: {
    borderRightWidth: 1,
    borderRightColor: '#000',
    paddingRight: 5,
    flexGrow: 1,
    fontSize: '14px',
    width: '100%',
    display: 'flex',
    // height: '100% !important',
    height: '100%',
    textAlign: 'center',
    // height: '6rem',
  },
  tableHeader: {
    fontWeight: 'bold',
    width: '100%',
    display: 'flex',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    flexDirection: 'row',
  },
});

const InVoicePdf = ({ item }) => {
  const orderDate = moment(item?.created_at).format('DD MMMM YYYY');
  return (
    <>
      <Document>
        <Page size="A4">
          <View style={styles.container}>
            <View style={styles.flex}>
              <View style={styles.flexCol}>
                <Svg
                  width="243"
                  height="24"
                  viewBox="0 0 243 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <Path
                    d="M13.625 0.828125C16.2708 0.828125 18.4479 1.63021 20.1562 3.23438C21.9583 4.93229 22.8594 7.21354 22.8594 10.0781C22.8594 12.4323 22.2552 14.651 21.0469 16.7344C19.8385 18.8073 18.2031 20.4427 16.1406 21.6406C14.151 22.7969 11.9479 23.375 9.53125 23.375C7.69792 23.375 6.10938 22.9948 4.76562 22.2344C3.42188 21.474 2.35417 20.4115 1.5625 19.0469C0.78125 17.6719 0.390625 16.1042 0.390625 14.3438C0.390625 11.9583 0.989583 9.71354 2.1875 7.60938C3.39583 5.49479 5.02083 3.83854 7.0625 2.64062C9.10417 1.43229 11.2917 0.828125 13.625 0.828125ZM13.7188 2.48438C11.9479 2.48438 10.3125 2.97917 8.8125 3.96875C7.32292 4.94792 6.07812 6.4375 5.07812 8.4375C4.07812 10.4375 3.57812 12.5417 3.57812 14.75C3.57812 16.1458 3.84375 17.3906 4.375 18.4844C4.90625 19.5677 5.625 20.3854 6.53125 20.9375C7.44792 21.4896 8.49479 21.7656 9.67188 21.7656C11.3594 21.7656 12.9479 21.2656 14.4375 20.2656C15.9375 19.2656 17.1875 17.7552 18.1875 15.7344C19.1979 13.7031 19.7031 11.5833 19.7031 9.375C19.7031 8 19.4323 6.79167 18.8906 5.75C18.3594 4.69792 17.6406 3.89062 16.7344 3.32812C15.8281 2.76562 14.8229 2.48438 13.7188 2.48438ZM27.4531 1.20312H36.6406C38.4427 1.20312 39.8073 1.41146 40.7344 1.82812C41.6615 2.23438 42.3854 2.84375 42.9062 3.65625C43.4375 4.45833 43.7031 5.39583 43.7031 6.46875C43.7031 7.82292 43.3073 9.09375 42.5156 10.2812C41.724 11.4583 40.6458 12.3438 39.2812 12.9375C38.0833 13.4479 36.1458 13.7031 33.4688 13.7031H30.2656L28.9688 19.4062C28.8646 19.8646 28.8125 20.2292 28.8125 20.5C28.8125 20.75 28.8802 20.9688 29.0156 21.1562C29.151 21.3438 29.3281 21.4792 29.5469 21.5625C29.7656 21.6458 30.1719 21.6875 30.7656 21.6875H31.3594L31.0781 23H22.5L22.7969 21.6875H23.4688C24.3542 21.6875 24.974 21.5365 25.3281 21.2344C25.6927 20.9323 25.9792 20.3229 26.1875 19.4062L29.4531 4.96875C29.5885 4.38542 29.6562 3.99479 29.6562 3.79688C29.6562 3.48438 29.5781 3.22396 29.4219 3.01562C29.2656 2.79688 29.0729 2.65625 28.8438 2.59375C28.6667 2.55208 28.0938 2.53125 27.125 2.53125L27.4531 1.20312ZM32.7188 2.95312L30.625 12.0781H33.0156C34.9323 12.0781 36.2344 11.9688 36.9219 11.75C37.9635 11.4375 38.8385 10.8021 39.5469 9.84375C40.2552 8.88542 40.6094 7.79167 40.6094 6.5625C40.6094 5.66667 40.3802 4.92708 39.9219 4.34375C39.474 3.76042 38.8854 3.36458 38.1562 3.15625C37.6771 3.02083 36.7552 2.95312 35.3906 2.95312H32.7188ZM62.8438 0.515625L63.6562 6.98438L62.1562 7.28125C61.9479 6.07292 61.6302 5.14062 61.2031 4.48438C60.776 3.81771 60.2604 3.33854 59.6562 3.04688C59.0625 2.75521 58.1458 2.60938 56.9062 2.60938C56.5625 2.60938 56.3281 2.66146 56.2031 2.76562C56.0885 2.85938 55.9896 3.09375 55.9062 3.46875L52.2812 19.4844C52.1979 19.8906 52.1562 20.224 52.1562 20.4844C52.1562 20.7552 52.2292 20.9948 52.375 21.2031C52.5312 21.401 52.7396 21.5312 53 21.5938C53.2708 21.6562 53.8385 21.6875 54.7031 21.6875L54.4219 23H45.8125L46.125 21.6875C46.8646 21.6771 47.4115 21.6458 47.7656 21.5938C48.1198 21.5417 48.3906 21.4479 48.5781 21.3125C48.776 21.1667 48.9375 20.9635 49.0625 20.7031C49.2708 20.2656 49.401 19.9271 49.4531 19.6875L53.0469 3.71875C53.1198 3.39583 53.1562 3.15625 53.1562 3C53.1562 2.86458 53.099 2.76562 52.9844 2.70312C52.8802 2.64062 52.6406 2.60938 52.2656 2.60938C51.224 2.60938 50.3333 2.77604 49.5938 3.10938C48.8646 3.43229 48.1094 4.00521 47.3281 4.82812C46.8281 5.34896 46.1719 6.23438 45.3594 7.48438L44.0781 6.75L47.4375 0.515625H48.5156V1.20312H61.4062L61.6875 0.515625H62.8438ZM65.4844 1.20312H74.0938L73.7969 2.53125H73.2969C72.5156 2.53125 71.9688 2.59896 71.6562 2.73438C71.3438 2.85938 71.0885 3.06771 70.8906 3.35938C70.7031 3.64062 70.5156 4.18229 70.3281 4.98438L67.1094 19.1562C66.9635 19.8229 66.8906 20.276 66.8906 20.5156C66.8906 20.9115 67.0573 21.224 67.3906 21.4531C67.6198 21.6094 68.0677 21.6875 68.7344 21.6875H69.4688L69.1406 23H60.5469L60.8438 21.6875H61.4688C62.1667 21.6875 62.6719 21.6198 62.9844 21.4844C63.3073 21.3385 63.5573 21.1354 63.7344 20.875C63.9219 20.6042 64.1042 20.0938 64.2812 19.3438L67.5781 4.82812C67.6927 4.32812 67.75 3.96354 67.75 3.73438C67.75 3.45312 67.6875 3.22396 67.5625 3.04688C67.4375 2.85938 67.2604 2.72917 67.0312 2.65625C66.8021 2.57292 66.3802 2.53125 65.7656 2.53125H65.2188L65.4844 1.20312ZM93.5781 1.29688H94.7656L95.0469 8.53125L93.5781 8.71875C93.1302 7.08333 92.6146 5.86458 92.0312 5.0625C91.4583 4.25 90.7396 3.63021 89.875 3.20312C89.0208 2.77604 88.0521 2.5625 86.9688 2.5625C85.3021 2.5625 83.724 3.05208 82.2344 4.03125C80.7448 5 79.5104 6.4375 78.5312 8.34375C77.5625 10.2396 77.0781 12.2344 77.0781 14.3281C77.0781 15.724 77.3698 16.974 77.9531 18.0781C78.5365 19.1719 79.3438 20.0208 80.375 20.625C81.4062 21.2188 82.5469 21.5156 83.7969 21.5156C84.7135 21.5156 85.6615 21.3698 86.6406 21.0781C87.6302 20.7865 88.526 20.3906 89.3281 19.8906C90.1406 19.3802 91.3646 18.3854 93 16.9062L93.9531 17.7969C92.3177 19.6615 90.5 21.099 88.5 22.1094C86.8333 22.9531 85.0365 23.375 83.1094 23.375C80.9948 23.375 79.3333 22.9896 78.125 22.2188C76.9167 21.4479 75.8906 20.4323 75.0469 19.1719C74.2135 17.901 73.7969 16.2656 73.7969 14.2656C73.7969 11.8906 74.3906 9.66146 75.5781 7.57812C76.776 5.49479 78.3802 3.84896 80.3906 2.64062C82.4115 1.43229 84.5625 0.828125 86.8438 0.828125C87.75 0.828125 88.6458 0.942708 89.5312 1.17188C90.1979 1.33854 90.8021 1.57812 91.3438 1.89062C91.7188 2.10938 92.151 2.45833 92.6406 2.9375L93.5781 1.29688ZM114.125 1.20312H115.266L115.391 8.10938H113.859C113.464 6.55729 112.661 5.24479 111.453 4.17188C110.245 3.08854 108.734 2.54688 106.922 2.54688C105.911 2.54688 105 2.72917 104.188 3.09375C103.385 3.45833 102.776 3.9375 102.359 4.53125C101.943 5.11458 101.734 5.69271 101.734 6.26562C101.734 6.76562 101.865 7.23438 102.125 7.67188C102.396 8.09896 102.849 8.51042 103.484 8.90625C104.12 9.30208 105.229 9.77604 106.812 10.3281C109.125 11.1406 110.703 11.8229 111.547 12.375C112.401 12.9271 113.036 13.5625 113.453 14.2812C113.87 15 114.078 15.7708 114.078 16.5938C114.078 17.7188 113.714 18.8177 112.984 19.8906C112.266 20.9635 111.26 21.8125 109.969 22.4375C108.677 23.0625 107.167 23.375 105.438 23.375C104.062 23.375 102.859 23.1823 101.828 22.7969C100.797 22.4115 99.724 21.7344 98.6094 20.7656L97.2969 23H96.2656L96.6094 15.0156H98.0781C98.4635 17.1094 99.3125 18.7448 100.625 19.9219C101.948 21.0885 103.547 21.6719 105.422 21.6719C107.151 21.6719 108.62 21.1927 109.828 20.2344C110.818 19.4427 111.312 18.4688 111.312 17.3125C111.312 16.6146 111.115 16 110.719 15.4688C110.333 14.9375 109.656 14.4323 108.688 13.9531C108.146 13.6927 106.839 13.1979 104.766 12.4688C102.818 11.7708 101.469 11.0521 100.719 10.3125C99.6771 9.26042 99.1562 8.07812 99.1562 6.76562C99.1562 5.79688 99.474 4.85417 100.109 3.9375C100.755 3.02083 101.698 2.27604 102.938 1.70312C104.177 1.11979 105.568 0.828125 107.109 0.828125C108.266 0.828125 109.312 0.994792 110.25 1.32812C111.198 1.65104 112.141 2.17708 113.078 2.90625L114.125 1.20312ZM129.375 1.20312H137.984L137.656 2.53125H136.984C136.234 2.53125 135.719 2.59375 135.438 2.71875C135.156 2.83333 134.927 3.03125 134.75 3.3125C134.521 3.67708 134.323 4.23438 134.156 4.98438L132.828 10.9688H144.547L145.953 4.79688C146.099 4.16146 146.172 3.77604 146.172 3.64062C146.172 3.41146 146.089 3.19271 145.922 2.98438C145.755 2.77604 145.547 2.64062 145.297 2.57812C145.141 2.54688 144.562 2.53125 143.562 2.53125L143.906 1.20312H152.5L152.188 2.53125H151.438C150.771 2.53125 150.281 2.60417 149.969 2.75C149.667 2.88542 149.427 3.08854 149.25 3.35938C149.073 3.61979 148.891 4.16146 148.703 4.98438L145.375 19.4844C145.281 19.901 145.234 20.2292 145.234 20.4688C145.234 20.8958 145.401 21.224 145.734 21.4531C145.953 21.6094 146.427 21.6875 147.156 21.6875H147.828L147.531 23H138.906L139.203 21.6875H139.781C140.396 21.6875 140.828 21.6562 141.078 21.5938C141.328 21.5208 141.547 21.4115 141.734 21.2656C141.932 21.1094 142.094 20.9062 142.219 20.6562C142.354 20.4062 142.479 20.0156 142.594 19.4844L144.156 12.6562H132.422L130.906 19.25C130.781 19.7917 130.719 20.2083 130.719 20.5C130.719 20.75 130.797 20.9792 130.953 21.1875C131.12 21.3854 131.344 21.5208 131.625 21.5938C131.823 21.6562 132.38 21.6875 133.297 21.6875L133 23H124.375L124.703 21.6875H125.203C125.839 21.6875 126.286 21.651 126.547 21.5781C126.818 21.5052 127.047 21.3906 127.234 21.2344C127.432 21.0781 127.578 20.901 127.672 20.7031C127.849 20.3385 128.005 19.8542 128.141 19.25L131.406 4.98438C131.542 4.38021 131.609 3.95312 131.609 3.70312C131.609 3.46354 131.542 3.24479 131.406 3.04688C131.281 2.83854 131.12 2.70312 130.922 2.64062C130.734 2.56771 130.339 2.53125 129.734 2.53125H129.031L129.375 1.20312ZM163.156 1.20312H165.812L169.031 19.4219C169.167 20.1719 169.312 20.6823 169.469 20.9531C169.625 21.224 169.818 21.4115 170.047 21.5156C170.286 21.6198 170.75 21.6771 171.438 21.6875L171.156 23H163.156L163.516 21.6875H164.391C165.099 21.6875 165.594 21.5677 165.875 21.3281C166.156 21.0885 166.297 20.7604 166.297 20.3438C166.297 20.1146 166.26 19.7604 166.188 19.2812L165.438 14.8906H157.094L154.281 19.8125C154.052 20.2188 153.938 20.5677 153.938 20.8594C153.938 21.1198 154.042 21.3229 154.25 21.4688C154.469 21.6146 154.922 21.6875 155.609 21.6875H156.344L156.031 23H148.75L149.062 21.6875C149.76 21.6667 150.255 21.6042 150.547 21.5C150.839 21.3854 151.099 21.2083 151.328 20.9688C151.568 20.7292 151.948 20.1667 152.469 19.2812L163.156 1.20312ZM165.188 13.375L163.578 3.6875L158 13.375H165.188ZM176.141 1.20312H184.109L183.828 2.53125H183.047C182.432 2.53125 182.01 2.57812 181.781 2.67188C181.552 2.75521 181.365 2.91146 181.219 3.14062C181.083 3.35938 181.016 3.63542 181.016 3.96875C181.016 4.29167 181.047 4.67188 181.109 5.10938L183.328 20.4844L191.969 4.92188C192.354 4.22396 192.547 3.69792 192.547 3.34375C192.547 3.04167 192.401 2.81771 192.109 2.67188C191.911 2.57812 191.516 2.53125 190.922 2.53125H190.141L190.438 1.20312H197.797L197.484 2.53125C196.818 2.53125 196.344 2.58333 196.062 2.6875C195.781 2.78125 195.516 2.95833 195.266 3.21875C195.016 3.47917 194.672 3.98438 194.234 4.73438L183.703 23H181.109L178.25 5.10938C178.104 4.19271 177.958 3.59375 177.812 3.3125C177.667 3.02083 177.474 2.81771 177.234 2.70312C176.995 2.58854 176.526 2.53125 175.828 2.53125L176.141 1.20312ZM199.109 1.20312H214.828L216.625 6.96875L215.188 7.42188C214.76 6.24479 214.266 5.34896 213.703 4.73438C213.151 4.10938 212.542 3.67708 211.875 3.4375C210.99 3.125 209.818 2.96875 208.359 2.96875H204.344L202.547 10.9531H205.188C206.302 10.9531 207.125 10.8385 207.656 10.6094C208.188 10.3802 208.635 10.0104 209 9.5C209.375 8.97917 209.661 8.23438 209.859 7.26562H211.359L209.359 16.1094H207.844C208 15.3073 208.078 14.75 208.078 14.4375C208.078 14.0312 207.964 13.6667 207.734 13.3438C207.505 13.0104 207.203 12.776 206.828 12.6406C206.464 12.5052 205.776 12.4375 204.766 12.4375H202.219L200.453 20.0938C200.38 20.4375 200.344 20.6615 200.344 20.7656C200.344 20.974 200.427 21.1354 200.594 21.25C200.708 21.3229 201.031 21.3594 201.562 21.3594H205.047C206.755 21.3594 208.146 21.1771 209.219 20.8125C210.302 20.4479 211.219 19.9167 211.969 19.2188C212.729 18.5104 213.594 17.2969 214.562 15.5781L215.922 16.1094L212.609 23H194.188L194.484 21.6875C195.547 21.6771 196.229 21.625 196.531 21.5312C196.833 21.4271 197.068 21.2552 197.234 21.0156C197.505 20.6406 197.719 20.099 197.875 19.3906L201.156 4.90625C201.281 4.375 201.344 4.00521 201.344 3.79688C201.344 3.31771 201.188 2.98958 200.875 2.8125C200.562 2.625 200.042 2.53125 199.312 2.53125H198.828L199.109 1.20312ZM220.859 1.20312H227.516L233.453 18.1875L236.516 4.65625C236.609 4.21875 236.656 3.90625 236.656 3.71875C236.656 3.3125 236.5 3.01042 236.188 2.8125C235.969 2.6875 235.516 2.625 234.828 2.625H234.141L234.422 1.20312H242.047L241.75 2.625H241.141C240.411 2.625 239.891 2.6875 239.578 2.8125C239.266 2.9375 239.021 3.13021 238.844 3.39062C238.667 3.64062 238.49 4.15104 238.312 4.92188L234.141 23H232.344L225.234 2.8125L221.438 19.4844C221.344 19.8698 221.297 20.1875 221.297 20.4375C221.297 20.6979 221.365 20.9323 221.5 21.1406C221.635 21.3385 221.812 21.4792 222.031 21.5625C222.26 21.6458 222.693 21.6875 223.328 21.6875H223.859L223.562 23H215.922L216.203 21.6875H216.875C217.594 21.6875 218.099 21.6198 218.391 21.4844C218.682 21.349 218.927 21.1198 219.125 20.7969C219.333 20.474 219.526 19.901 219.703 19.0781L222.953 4.92188C223.057 4.46354 223.109 4.08333 223.109 3.78125C223.109 3.34375 222.958 3.02604 222.656 2.82812C222.438 2.69271 222 2.625 221.344 2.625H220.578L220.859 1.20312Z"
                    fill="#023047"
                  />
                </Svg>
                <View style={styles.maxWidth}>
                  <Text style={{ marginTop: '16px' }}>
                    1305 West 7th St Suite 1 -1063 Frederick, MD 21702
                  </Text>
                </View>
              </View>
              <View>
                <Text
                  style={styles.invoice}
                >{`#${item?.sequence_no} Invoice`}</Text>
              </View>
            </View>
            <View style={styles.flex}>
              <View>
                <Text>Customer Details:</Text>
                <View style={styles.maxWidth}>
                  <Text style={styles.onlyFlex}>
                    Name:{' '}
                    {`${item?.user_id?.firstname} ${item?.user_id?.lastname}` ?? `${item?.user_id?.username}`}
                  </Text>
                  <Text style={styles.flex}>
                    Mob No. {item?.user_id?.mobile}
                  </Text>
                </View>

                <Text>Shipping Address:</Text>
                <View style={styles.maxWidth}>
                  <Text style={styles.onlyFlex}>
                    Name:{' '}
                    {`${item?.shipping_address_data?.firstname} ${item?.shipping_address_data?.lastname}`}
                  </Text>
                  <Text style={styles.onlyFlex}>
                    {`${item?.shipping_address_data?.address}, ${item?.shipping_address_data?.city}, ${item?.shipping_address_data?.state}, ${item?.shipping_address_data?.zipcode}`}
                  </Text>
                  <Text style={styles.flex}>
                    Mob No. {item?.shipping_address_data?.mobile_no}
                  </Text>
                </View>
              </View>
              <View>
                <Text
                  style={{
                    display: 'flex',
                    justifyContent: 'column',
                  }}
                >
                  Order ID : {`#${item?._id}`}
                </Text>
                <Text
                  style={{
                    display: 'flex',
                    justifyContent: 'column',
                  }}
                >
                  Order Date : {orderDate}
                </Text>
              </View>
            </View>

            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                borderWidth: 1,
                borderColor: '#000',
              }}
            >
              {/* Table Header */}
              <View style={styles.tableHeader}>
                <Text style={styles.tableCell}>Sl. ID</Text>
                <Text style={styles.tableCell}>Name</Text>
                <Text style={styles.tableCell}>Lens</Text>
                <Text style={styles.tableCell}>Qty</Text>
                <Text style={styles.tableCell}>Price</Text>
              </View>
              {/* Table Rows */}
              <View
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {item?.items?.map((x, index) => {
                  let product = {
                    name: '',
                    lenseName: '',
                    image: '',
                    color: '',
                    size: '',
                    model: '',
                    sku: '',
                    price: x?.product_price || x?.accessory_price || 0,
                  };
                  if (Object.hasOwnProperty.call(x, 'product_image')) {
                    product.image = x?.product_image;
                    product.name = x?.product_name;
                    product.size = x?.product_size_name;
                    product.color = x?.product_color;
                    product.sku = x?.product_sku_no;
                    if (x?.lenses?.lense_id) {
                      product.lenseName =
                        product.lenseName +
                        x?.lenses?.lense_id?.prescription_type;
                      product.price = product.price + x?.lenses?.lens_price;
                    }
                    if (x?.lenses?.singlevision_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.singlevision_id?.single_vision_type;
                      product.price =
                        product.price + x?.lenses?.singlevision_price;
                    }
                    if (x?.lenses?.lense_type_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.lense_type_id?.lenses_type;
                      product.price =
                        product.price + x?.lenses?.lens_type_price;
                    }
                    if (x?.lenses?.lens_type_color_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.lens_type_color_id?.color_name;
                    }
                    if (x?.lenses?.material_type_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.material_type_id?.lens_material_type;
                      product.price =
                        product.price + x?.lenses?.material_type_price;
                    }
                  } else if (Object.hasOwnProperty.call(x, 'accessory_image')) {
                    product.image = x.accessory_image;
                    product.name = x?.accessory_name;
                  } else if (x?.lenses?.is_use_my_frame) {
                    product.name = x?.lenses?.use_my_frame_id?.frame_name;
                    product.image =
                      x?.lenses?.use_my_frame_id?.frame_image?.[0];
                    if (x?.lenses?.lense_id) {
                      product.lenseName =
                        product.lenseName +
                        x?.lenses?.lense_id?.prescription_type;
                      product.price =
                        product.price + x?.lenses?.lense_id?.price;
                    }
                    if (x?.lenses?.singlevision_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.singlevision_id?.single_vision_type;
                      product.price =
                        product.price + x?.lenses?.singlevision_id?.price;
                    }
                    if (x?.lenses?.lense_type_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.lense_type_id?.lenses_type;
                      product.price =
                        product.price + x?.lenses?.lense_type_id?.price;
                    }
                    if (x?.lenses?.lens_type_color_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.lens_type_color_id?.color_name;
                    }
                    if (x?.lenses?.material_type_id) {
                      product.lenseName =
                        product.lenseName +
                        ' + ' +
                        x?.lenses?.material_type_id?.lens_material_type;
                      product.price =
                        product.price + x?.lenses?.material_type_id?.price;
                    }
                  }
                  return (
                    <View key={index} style={styles.tableRow}>
                      <Text style={styles.tableCell}>{index + 1}</Text>
                      <Text style={styles.tableCell}>
                        {`${product.name ? product.name : product.lenseName
                          }${product.color && `, (${product.color}),`}${product.size && ` ${product.size},`}${product.model && ` ${product.model},`}${product.sku && ` ${product.sku}`}`}</Text>
                      <Text style={styles.tableCell}>
                        {product.lenseName ? product.lenseName : '-'}
                      </Text>
                      <Text style={styles.tableCell}>{x.quantity}</Text>
                      <Text
                        style={styles.tableCell}
                      >{`$${product.price}`}</Text>
                    </View>
                  );
                })}
              </View>
            </View>
            <View style={styles.total}>
              <Text>TOTAL: </Text>
              <Text style={{ textAlign: 'end' }}>${item?.total_price}</Text>
            </View>
          </View>
        </Page>
      </Document>
    </>
  );
};

export default InVoicePdf;
